/* eslint-disable react-hooks/exhaustive-deps */

import { Grid, Box, Container, Typography, useMediaQuery, useTheme } from "@mui/material";
import { RootState } from "@store/store";
import { useLocation, useNavigate } from "react-router-dom";
import IconSpeed from "@components/Images/IconSpeed";
import { useSelector } from "react-redux";
import { useLazyGetLoanApplicationByIdQuery } from "@api/applications";
import { useEffect } from "react";
import Confetti from "react-confetti";
import { getProductBaseRoute } from "@helpers/funciones";

const SECONDS_TO_FETCH = 10 * 1000;

const WaitingRoomMarketPlace = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const baseRoute = getProductBaseRoute(pathname);

  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));
  const company = useSelector((state: RootState) => state.register.company);
  const application = useSelector((state: RootState) => state.register.application);
  const [getLoadApplication] = useLazyGetLoanApplicationByIdQuery();

  useEffect(() => {
    const intervalFetch = setInterval(async () => {
      try {
        const response = await getLoadApplication(application.id).unwrap();
        const url_actual = response?.status_catalog?.url_actual || response?.current_status?.url || response?.status_catalog?.url || "";

        if (!url_actual) return;

        // Normaliza por si el backend llegara a mandar un path relativo.
        const targetUrl = url_actual.startsWith("/") ? url_actual : `${baseRoute}${url_actual.replace(/^\/+/, "")}`;

        // Si ya estamos en la misma ruta, no navegamos (evita side-effects innecesarios).
        const currentUrl = `${pathname}${search}`;
        if (targetUrl !== currentUrl) {
          navigate(targetUrl, { replace: true });
        }
      } catch (error) {
        console.log("Ha ocurrido un error", error);
      }
    }, SECONDS_TO_FETCH);

    return () => {
      intervalFetch && clearInterval(intervalFetch);
    };
  }, []);

  return (
    <>
      <Grid container sx={{ position: "relative" }} height="90%">
        <Confetti className="confetti-container" numberOfPieces={2000} tweenDuration={20000} recycle={false} />
        <Grid item xs={12} md={12}>
          <Box
            sx={{
              mt: 6,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Container sx={{ mb: 1 }}>
              <Typography
                fontSize={"31px"}
                fontWeight={"600"}
                align="center"
                color={theme?.palette?.primary?.dark}
                lineHeight={"39.06px"}
              >
                ¡Listo {company.name}! <br />
                ¡Tu solicitud fue enviada con éxito!
              </Typography>
            </Container>

            <Box sx={{ mb: 1 }}>
              <Typography
                fontWeight={600}
                variant={isMobileOrTablet ? "body2" : "body1"}
                color={theme?.palette?.primary?.main}
                align="center"
                width={isMobileOrTablet ? "280px" : "400px"}
              >
                Gracias por confiar en PyMio by Lendia. Hemos enviado tu solicitud a nuestras instituciones financieras
                aliadas.
              </Typography>
            </Box>

            <Box sx={{ mt: 1, mb: 1 }}>
              <Typography
                fontWeight={300}
                variant={isMobileOrTablet ? "body2" : "body1"}
                color={theme?.palette?.primary?.dark}
                align="center"
                width={isMobileOrTablet ? "290px" : "400px"}
              >
                En caso de recibir ofertas, te las presentaremos al cumplir 48 horas. Las financieras evaluarán tu
                perfil y, bajo condiciones equitativas, te ofrecerán la mejor opción disponible, recibiendo todas tus
                ofertas al mismo tiempo!
              </Typography>
            </Box>

            <Box sx={{ mt: 2, mb: 2 }}>
              <IconSpeed fill={theme.palette.primary.dark} />
            </Box>

            <Box sx={{ mt: 2, mb: 1 }}>
              <Typography
                fontWeight={"300"}
                variant={isMobileOrTablet ? "body2" : "body1"}
                color={theme?.palette?.primary?.dark}
                align="center"
                width={isMobileOrTablet ? "280px" : "400px"}
              >
                ¡Despreocúpate! Puedes salir de esta pantalla, tan pronto recibas ofertas personalizadas podrás
                consultarlas aquí mismo y te la enviaremos vía WhatsApp
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default WaitingRoomMarketPlace;
